<template>
	<el-table :data="tableData" border style="width: 100%">
		<el-table-column
			label="序号"
			align="center"
			width="50"
			type="index"
		></el-table-column>
		<el-table-column
			v-for="(item, index) in data.columnList"
			:key="index"
			:label="item.label"
			:prop="item.prop"
			align="center"
		>
			<template #default="scope" v-if="item.prop == 'isDelete'">
				{{ scope.row.isDelete == 0 ? "正常" : "停用" }}
			</template>
		</el-table-column>
		<el-table-column label="操作" align="center">
			<template #default="scope">
				<el-button
					type="primary"
					size="mini"
					@click="handleEdit(scope.row)"
					>编辑</el-button
				>
			</template>
		</el-table-column>
	</el-table>
	<el-dialog title="配置信息" width="500px" v-model="data.dialogTableVisible">
		<el-form label-width="90px">
			<el-form-item label="名称">
				{{ data.currentData.paramName }}
			</el-form-item>
			<el-form-item label="数据">
				<el-input
					v-model="data.currentData.paramValue"
					placeholder="请输入所属停车场"
				></el-input>
			</el-form-item>
		</el-form>
		<footer class="tac" style="margin-top: 50px">
			<el-button type="primary" @click="handleSave">确定</el-button>
		</footer>
	</el-dialog>
</template>

<script>
import { reactive } from "vue";
import { apiSysParamUpdate } from "@/api/requestApis.js";
export default {
	props: {
		tableData: Array,
	},
	components: {},
	setup() {
		const data = reactive({
			dialogTableVisible: false,
			currentData: {},
			columnList: [
				{
					label: "名称",
					prop: "paramName",
				},
				{
					label: "数据",
					prop: "paramValue",
				},
				{
					label: "备注",
					prop: "remark",
				},
			],
		});
		const handleSave = async () => {
			await apiSysParamUpdate({
				id: data.currentData.id,
				paramValue: data.currentData.paramValue,
			});
			data.currentData = {};
			data.dialogTableVisible = false;
		};
		const handleEdit = (val) => {
			data.currentData = val;
			data.dialogTableVisible = true;
		};
		return {
			handleSave,
			handleEdit,
			data,
		};
	},
};
</script>

<style  scoped>
</style>
